(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function () {

    const NotyficationModule = require('./modules/notification.js');
    const FormModule = require('./modules/form.js');
    const StorageModule = require('./modules/sstorage');
    const LocalStorage = StorageModule.getLocalStorage();
    const AjaxModule = require('./modules/ajax');
    const ValidationModule = require('./modules/validation');

    window.displayMessage = NotyficationModule.displayMessage;
    
    // what to validate (config)
    const fieldsToValidate = {
        login: [
            {
                name: 'login',
                multi: false,
                keys: [],
                rules: ['isNotEmpty'],
                error: `The Username Field is Required`
            },
            {
                name: 'password',
                multi: false,
                keys: [],
                rules: ['isNotEmpty'],
                error: `The Password Field is Required`
            },
        ],
        reset: [
            {
                name: 'login',
                multi: false,
                keys: [],
                rules: ['isNotEmpty'],
                error: `The Username Field is Required`
            }
        ]
    };

    function Auth() {

        this.login = (form) => {

            const postData = form.serializeArray();

            AjaxModule.beforeCallback();
            ValidationModule.run(fieldsToValidate.login, postData, form, false)
            .then(() => AjaxModule.send('POST','/login/check_user',$.param(postData)))
            .then((data) => {

                if(data.success && data.data.hasOwnProperty('target')) location.href = data.data.target;
                else if(data.msg) {
                    AjaxModule.completeCallback();
                    AjaxModule.responseCallback(data);
                }
            })
            .catch(error => {
                AjaxModule.completeCallback();
                if(error != null) AjaxModule.errorCallback(error);
            })
        }

        this.resetPassword = (form) => {

            const postData = form.serializeArray();

            postData.push({name: 'send_forgotten_password', value: '1'});

            ValidationModule.run(fieldsToValidate.reset, postData, form)
                .then(() => NotyficationModule.sAlert({
                        title: "Are You Sure?",
                        text: " Please confirm that you would like to reset your password ",
                        icon: "warning",
                        buttons: [true, "Yes, reset it!"],
                        dangerMode: true,
                        focus: false,
                        callback: (value) => {
                            if (value) {

                                AjaxModule.beforeCallback();

                                AjaxModule.sendPostRequest('/login/check_user', $.param(postData))
                            }
                        }
                    }))
                .catch(error => {
                    AjaxModule.completeCallback();
                    if(error != null) AjaxModule.errorCallback(error);
                });
        };
    }

    $('document').ready(function () {

        const auth = new Auth();

        /** remove "Daily Notes" key
         * see "alert" method of "Notes" class in reports.js
         */
        LocalStorage.delete('daily_notes');

        $('#forgot-password-link').click(function (e) {
            const event = e || window.event;
            event.preventDefault();

            const form = $('#loginForm');

            // reset "password" field error
            $('input[name="password"]').removeClass('is-invalid');

            auth.resetPassword(form);
        });

        $('#loginForm').submit(function (e) {
            const event = e || window.event;
            event.preventDefault();

            const btn = e.target.querySelector('.submit-button');
            btn.currentTarget = btn;

            $(e.target).find('input').removeClass('is-invalid');

            auth.login($(e.target));
        });

        $('body').on('focusout', 'input.has-validation', function (e) {

            ValidationModule.run(fieldsToValidate.login, $('#loginForm').serializeArray(), $('#loginForm'), false)
            .catch(error => {
                AjaxModule.completeCallback();
                if(error != null) console.log(error);
            });
        });
    });
})();
},{"./modules/ajax":2,"./modules/form.js":3,"./modules/notification.js":4,"./modules/sstorage":5,"./modules/validation":6}],2:[function(require,module,exports){
const NotyficationModule = require('./notification.js');

function secureFormData(data) {
    let csrf_name = '';
    let csrf_hash = '';

    if(typeof csfrData != 'undefined') {
        for(key in csfrData) {
            csrf_name = key;
            csrf_hash = csfrData[key];
        }
        data.append(csrf_name, csrf_hash);
    }

    return data;
}

module.exports = {
	send: (method,url,data,headers) => {

        return new Promise((resolve,reject) => {

            const request = new XMLHttpRequest();
            request.open(method,url);

            request.setRequestHeader('x-requested-with', 'XMLHttpRequest');

            if(typeof headers!='undefined') {

                headers.forEach(header => request.setRequestHeader(header.key, header.value));
            }

            request.onload = function() {
                try {
                    if(this.status == 200) {
                        return resolve(JSON.parse(this.response));
                    } else {
                        const resp = JSON.parse(this.response);
                        if(resp.err) return reject(resp.err);
                        return reject(this.status + " " + this.statusText);
                    }
                } catch(e) {
                    if(e instanceof Error) return reject(e.message);
                    else return reject('Unknown Error');
                }
            }

            request.onerror = function() {
                return reject(this.status + '' + this.statusText);
            }

            if(typeof data!='undefined') {

                if(typeof headers=='undefined' && !(data instanceof FormData)) request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

                request.send(data instanceof FormData ? secureFormData(data) : data);
                
            }
            else {
                
                // // add csfr token and random param to all post requests(if no FORM submit)
                // if(method=='POST') {
                //     data = JSON.parse(JSON.stringify(csfrData));
                //     data['_'] = new Date().getTime();
                //     data = $.param(data);
                    
                //     request.send(data);
                // }

                request.send();
            }
        });
	},

    sendPostRequest: function(url,data,resolve=_=>null,reject=_=>null) {

        this.beforeCallback();

        this.send('POST',url,data)
        .then(data => {
            this.completeCallback();
            this.responseCallback(data);

            if(data.success) resolve(data.data);
            else reject(data);
        })
        .catch(error => {
            this.completeCallback();
            if(error != null) this.errorCallback(error);
        });
    },

    sendGetRequest: function(url,resolve=_=>null,reject=_=>null) {

        this.beforeCallback();

        this.send('GET',url)
        .then(data => {
            this.completeCallback();
            this.responseCallback(data);

            if(data.success) resolve(data.data);
            else reject(data);
        })
        .catch(error => {
            this.completeCallback();
            if(error != null) this.errorCallback(error);
        });
    },

    beforeCallback: context => {
        
        if(typeof context != 'undefined') {

            // custom progress bar here...
        } else $('#preloader').fadeIn();
    },

    errorCallback: error => {

        if(/^500\b/.test(error.toString()) || error.toString().indexOf('JSON') !== -1) {

            error = 'Something went wrong. Please try again later, or contact support if this error persists.';
        }

        NotyficationModule.displayMessage({
            title: 'Oops!',
            text: error,
            type: 'error'
        })
    },

    completeCallback: context => {

        if(typeof context != 'undefined') {

        } else $('#preloader').fadeOut();
    },

    responseCallback: data => {

        if(data.msg) {

            const messages = typeof data.msg === 'object' ? Object.keys(data.msg).map(i => data.msg[i]) : [data.msg];

            messages.map(m => NotyficationModule.displayMessage({
                title: data.success ? 'Success!' : 'Oops!',
                text: m,
                type: data.success ? 'success' : 'notice',
                sticky: data.success ? false : true,
                delay: 5000
            }))
        }
    }
}
},{"./notification.js":4}],3:[function(require,module,exports){
const NotyficationModule = require('./notification.js');
const AjaxModule = require('./ajax.js');
const ValidationModule = require('./validation.js');

const showError = function(text, raw) {

	// remove all errors for bound fields
    const setValid = () => {
        this.map((_,i) => $(i).removeClass('is-invalid'));
    }

	this.each(function(){

		$(this).addClass('is-invalid');
	    $(this).closest('.form-group').find('.invalid-feedback').html(text);
	    $(this).closest('.form-group').find('.invalid-feedback').show();

	    if(typeof raw == 'undefined') $(this).unbind('change keypress input'); // remove previous events listeners

	    if(this.tagName == 'SELECT') {

	        $(this).on('change', () => setValid());
	    } else {

	        $(this).on('keypress input change',function(event) {

	            if (event.which != 13) {
	                setValid();
	            }
	        });
	    }
	});
}

const registerKeypress = function() {

    $(this).find("input.form-control").on('keypress',function(event) {
        if (event.which == 13) {
            $(this).closest('.modal').find('.btn-secondary').trigger('click');
            $(this).closest('.modal').find('.btn-info').trigger('click');
        }
    });
}

module.exports = {
    // this one creates new form element, adds csrf token to its pre-defined content (HTMl) + submit the form
    submit: (attributes,content) => {

        var form = document.createElement('form');
        form.method = attributes.method;
        form.action = attributes.action;

        if(attributes.method==='POST') {

            var csrf_name = '';
            var csrf_hash = '';

            for(key in csfrData) {
                csrf_name = key;
                csrf_hash = csfrData[key];
            }

            content += '<input type="hidden" name="'+csrf_name+'" value="'+csrf_hash+'">';
        }

        form.insertAdjacentHTML('afterBegin',content);
        document.body.appendChild(form);
        form.submit();
    },

    // this one validates form according to config passed and then sends it
    handleForm: (form, fieldsToValidate, cb, errCb) => {

        const postData = $(form).serializeArray();

        ValidationModule.run(fieldsToValidate, postData, $(form))
        .then(() => {

            if (cb) cb();
            else {

                AjaxModule.beforeCallback();
                form.submit();
            }
        }, () => errCb && errCb())
        .catch(error => {
            AjaxModule.completeCallback();
            if(error != null) AjaxModule.errorCallback(error);
        });
    },

    // return DOM fragment which collects all elements from different forms 
    copyFormElements: (container) => {
        
        var fragment = document.createDocumentFragment();

        const inputs = container.querySelectorAll('input');
        const areas = container.querySelectorAll('textarea');
        const selects = container.querySelectorAll('select');

        for (var i = 0; i < inputs.length; i++) {
            var cln = inputs[i].cloneNode();
            fragment.appendChild(cln);
        }
        for (var a = 0; a < areas.length; a++) {
            var cln = areas[a].cloneNode(true);
            fragment.appendChild(cln);
        }
        for (var s = 0; s < selects.length; s++) {
            var cln = selects[s].cloneNode(true);
            fragment.appendChild(cln);
        }

        return fragment;
    },

    // handling form selects (should get fired when changing values)
    fixSelectAttributes: function() {

        const options = this && this.options;
        for (let i=0, iLen=options.length; i<iLen; i++) {
            let opt = options[i];

            if (opt.selected) {
                options[i].setAttribute("selected","");
            } else options[i].removeAttribute("selected");
        }
    },

    // show validation errors in correspond fields
    // %selector% is optional and may be used as target element
    showValidationErrors: function(selector) {

        if(typeof selector != 'undefined') selector = selector + ' ';
        else selector = '';

        const validationRegEx = /\w/;

        $(selector + '.invalid-feedback').each(function (i) {
            const error_text = $(this).text();
            const hasError = error_text.match(validationRegEx);

            if(hasError) {

                $(this).closest('.form-group').find('input').addClass('is-invalid');
                $(this).closest('.form-group').find('select').addClass('is-invalid');
            }
        });

        $('body').on('focus', selector + 'input.has-validation', function (e) {

            $(this).removeClass('is-invalid');

            $(this).one('focusout',function(event) {

                if(event.target.value == '') $(this).addClass('is-invalid');
	        });
        });

        $('body').on('keypress', selector + 'input.has-validation', function (e) {
            $(this).removeClass('is-invalid');
        });

        $('body').on('change', selector + 'select.has-validation', function (e) {
            $(this).removeClass('is-invalid');
        });

        $('body').on('input change', '.typeahead', function (e) {
            $(this).closest('div').find('.invalid-feedback').hide();
        });
    },

    // show validation error under context field
    // %text% presents text error
    // - to be shown {.invalid-feedback} element must be encapsulated into {.form-group}
    showValidationError: function(text) {

        showError.call(this,text);
    },

    showRawValidationError: function(text) {

        showError.call(this,text,true);
    },

    validateEmail: (value) => {

        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(value);
    },

    validateCreditCard: function(value) {

        value = value.replace(/\D/g,'');
        $(this).val(value);
        
        let regex = /^\d+$/;

        if (regex.test(value))
        return true;

        return false;
    },

    initMultiselect: function(data) {

        const conf = {
            buttonWidth: '100%',
            numberDisplayed: 1,
            includeSelectAllOption: true,
            nonSelectedText: 'All Selected (short format)',
            selectAllText: 'Select All',
            buttonTitle: function (options, select) {
                var labels = [];
                options.each(function () {
                    labels.push($(this).text());
                });
                return labels.join(' - ');
            }
        }

        for (k in data) {
            conf[k] = data[k];
        }

        $(this).multiselect(conf);
    },

	initToggle: function(data) {

        const conf = {
            on: mobileDetect.mobile() ? '' : 'Enable',
            off: mobileDetect.mobile() ? '' : 'Disable',
            size:  mobileDetect.mobile() ? 'mini' : 'small',
            width: mobileDetect.mobile() && 60
        }

        for (k in data) {
            conf[k] = data[k];
        }

        $(this).bootstrapToggle(conf);
    },

    initDatepicker: function (data, handlers) {

        // a field is readonly by default
        $(this).attr('readonly', true);

        const conf = {
            format: 'dd M yyyy',
            autoclose: true,
            maxViewMode: 2,
            endDate: endDatepickerLimit(),
            todayHighlight: true,
            clearBtn: true,
        };

        for (const k in data) {

            conf[k] = data[k];

            if(k == 'readonly' && !data[k]) $(this).removeAttr('readonly');
        }

        const element = $(this).datepicker(conf);

        element.on('changeDate', e => {

            if (handlers && "changeDate" in handlers) {

                handlers["changeDate"](e)
            }

            // fuse template input
            $(e.target).fuseMdInput();
        });

        for (const k in handlers) {

            if (k != "changeDate") element.on(k, e => handlers[k](e));
        }

        return element;
    },

    /**
     * {@link https://timepicker.co/} - plugin docs
     * @param {Object} config
     * */
    initTimepicker: function (config) {

        if (this === window || !this.length) return false; // if timepicker field not found

        if (mobileDetect.mobile()) $(this).attr('readonly', true); // readonly field on mobile devices

        // set readonly attribute true or false
        if (config && config.hasOwnProperty('readonlyField')) {

            $(this).attr('readonly', !!config.readonlyField);
        }

        $(this).timepicker({
            timeFormat: 'h:mma',
            interval: 5,
            dynamic: true,
            dropdown: true,
            scrollbar: true,
            zindex: 10000,
            ...config
        });

        // reset field on invalid input
        $(this).on('change', e => !$(e.target).timepicker().getTime() && (e.target.value = ''));

        // other stuff
        $(this).addClass('md-has-value');
    },
    
    /**
     * Dynamic set min/max date ranges 'from - to', e.g., the selected 'from' date is the 'start' date for 'to' date
     * and vice versa - selected 'to' date is the 'end' date for 'from'.
     *
     * @param context {jQuery}
     * */
    pairDates: context => {
        const from = context.find('[name*="date_from"],[name*="period[from]"],[name*="made[from]"],[name*="arrival[from]"],[name="valid_from"],[name="arrival_from"],[name="date_start"]');
        const to = context.find('[name*="date_to"],[name*="period[to]"],[name*="made[to]"],[name*="arrival[to]"],[name="valid_to"],[name="arrival_to"],[name="date_stop"]');

        from.datepicker('setEndDate', to.val());
        to.datepicker('setStartDate', from.val());
    },

    decodeHtml: html => {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    },

    escapeHtml: html => {
        return html
         .replace(/&/g, "&amp;")
         .replace(/</g, "&lt;")
         .replace(/>/g, "&gt;")
         .replace(/"/g, "&quot;")
         .replace(/'/g, "&#039;");
    },

    // To work next function require jquery.charcounter.js plugin
    enableTextCounter: function(q, config) {

        $(this).find(".counted").charCounter(q,{
            container: ".message-counter",
            format: "%1",
            pulse: false,
            ...config
        });
    },

    getDefaultCounterLimit: () => '180',

    // check for secret word while saving data
    secretWordWindow: function(tpls,callback) {

        const modalMarkup = $('#verify-pass').html();
        const wrapper = document.createElement("div");
        wrapper.className = 'modal-content-inner text-center';
        wrapper.innerHTML = tpls.Settings.secretword();

        const dialog = bootbox.dialog({
            message: wrapper,
            show: true,
            backdrop: true,
            closeButton: false,
            onEscape:true,
            animate: true,
            buttons: {
               "Cancel": {
                 className: "btn-default"
               },
               "Confirm": {
                    className: "btn-info",
                    callback: function() {

                        const input = $(this).find('input');
                        let value = input.val();

                        if(value === '') {

                            showError.call(input,'Please fill out this field.');

                            return false;
                        } else {

                            callback(value);
                        }
                    }
               }
            }
        })
        .init(function(){

            $('input.form-control').fuseMdInput();
            registerKeypress.call(this);
        });
        dialog.on('shown.bs.modal',function(){
            $('.bootbox-body input.form-control').focus();
        }); 
    },

    // register "ENTER" keypress event while handlind modals
    registerKeypress: function() {
        registerKeypress.call(this);
    },

    preventDoubleSubmission: (e, submit, timer) => {
        
        if(typeof e.currentTarget.attributes.disabled == 'undefined') {

            e.currentTarget.setAttribute('disabled',true);
            setTimeout(() => e.currentTarget.removeAttribute('disabled'), (typeof timer != 'undefined') ? timer : 5000);
            submit();
        }
    },

    // copy field content to clipboard
    clipboard: function() {

        $('body').on('click', '.btn-copy', function (e) {
            const event = e || window.event;
            event.preventDefault();

            const copyText = document.querySelector(`[name=${$(this).data('copy')}]`);
            
            copyText.select();

            document.execCommand("copy");

            NotyficationModule.displayMessage({
                type: 'success',
                title: 'Copied!',
                text: '',
                class: 'simple-notice',
                delay: 1500,
            });
        });
    },

    hasInternals: () => {

        return new Promise((resolve,reject) => {

            const highlighted = $('select.day_tickets,select.tickets-list').find('option.bg-grey-400:selected');

            if(highlighted.length) {

                NotyficationModule.sAlert({
                    title: "Are You Sure?",
                    text: 'You are selecting an internal ticket, select OK to continue.',
                    buttons: [true, "Ok"],
                    callback: value => {
                        
                        if (value) resolve();
                        else reject();
                    }
                });
    
            } else resolve();

        });
    },

    preventFormSubmitOnEnter: formSelector => $('body').on('keypress', formSelector, e => {

        return !(e.target.nodeName !== "TEXTAREA" && e.key === "Enter");
    }),
}

},{"./ajax.js":2,"./notification.js":4,"./validation.js":6}],4:[function(require,module,exports){
const displayMessageCounter = (() => {

	let counter = 0;

	return {

		val: () => counter,

		reset: () => counter = 0,

		increment: () => ++counter,

		decrement: () => counter > 0 ? --counter : 0
	}
})();

/**
 * Close all PNotify popups if more than 2
 * @param {Function} callback
 * */
function closeAllPopupsHandler(callback) {

	const closeAllPopupsBtn = $('.btn-close-all-popups');

	if(displayMessageCounter.val() > 1) {
		if (!closeAllPopupsBtn.is(':visible')) closeAllPopupsBtn.show();

		closeAllPopupsBtn
			.appendTo($('body'))
			.click(() => {

				closeAllPopups();

				if(typeof callback === "function") callback();
			});

		return;
	// do not delete the "Close all" button if one notification remains after deletion
	} else if(displayMessageCounter.val() && closeAllPopupsBtn.is(':visible')) return;

	closeAllPopupsBtn.hide().unbind();
}

function closeAllPopups() {

	PNotify.removeAll();
	
	$('.btn-close-all-popups').hide().unbind();
}


module.exports = {

	sAlert: (data) => {

		if(typeof data.callback == 'undefined') {

			if(typeof data.content != 'undefined') {

				swal({
	                title: data.title,
	                content: data.content,
	                buttons: typeof data.buttons != 'undefined' ? data.buttons : false,
	                className: typeof data.className != 'undefined' ? data.className : false,
	            });
			} else { swal( data.title, data.text, data.icon ) }
		}
		else {

				swal({
	                title: data.title,
	                text: data.text,
	                icon: data.icon,
	                buttons: data.buttons,
	                closeOnClickOutside: typeof data.closeOnClickOutside != 'undefined' ? data.closeOnClickOutside : true,
	                closeOnEsc: typeof data.closeOnEsc != 'undefined' ? data.closeOnEsc : true,
	                content: typeof data.content != 'undefined' ? data.content : false,
	                dangerMode: typeof data.dangerMode != 'undefined' ? data.dangerMode : false,
	                focus: typeof data.focus != 'undefined' ? data.focus : true,
					className: typeof data.className != 'undefined' ? data.className : false,
	            })
	            .then(data.callback);
		}
	},

	displayMessage: data => {

		/**
         *     PNotify default styling.
         */

		PNotify.defaults.styling = 'material';
        PNotify.defaults.icons = 'material';

        /**
         *     @type
         *	   'info','success','error','notice'
         */
		const type = (data.type != undefined ? data.type : 'notice');
		const delay = (data.delay != undefined ? data.delay : 3000);
		const hide = (data.sticky != undefined ? !data.sticky : true);

		$('.cart-edit-notice').hide();

		const conf = {
			titleTrusted: true,
			textTrusted: true,
			title: data.title,
			text: data.text,
			hide: hide,
			delay: delay,
			stack: (data.stack ? data.stack : PNotify.defaultStack),
			addClass: (data.class ? data.class : ''),
			modules: {},
			...data,
		};

		if (conf.modules.hasOwnProperty('Callbacks')) {
			conf.modules.Callbacks = {
				afterClose: () => closeAllPopupsHandler(displayMessageCounter.decrement()),
				...conf.modules.Callbacks
			}
		} else conf.modules = {
			Callbacks: {
				afterClose: () => closeAllPopupsHandler(displayMessageCounter.decrement()),
			}
		}

		PNotify[type](conf);

		displayMessageCounter.increment();

		closeAllPopupsHandler(displayMessageCounter.reset);
	},

	moveTripExeption: (data,order_id,item,log_error) => {

		var errors = '';
		if (data.msg.length > 0) {
			data.msg.forEach(function(item, i) {
			  	errors += (data.msg['0'] != item ? '. ' : '')+item;
			});
		}

		log_error += '<b class="red">Error reason:</b> ' + errors;
		errors += '<br>* <small><i>Order log has been updated. Reload page for review</i></small>';

		var el = document.createElement('div');
		el.innerHTML = errors;

		swal({
		  content: {
		    element: el
		  },
		  icon:'error',
		  closeOnClickOutside: false,
		  closeOnEsc: false,
		  dangerMode: true
		}) 

		$('#order-item-'+item).find("#arrival_date,select[name$='[inventory_id]'],select[name$='[schedule_id]']").each(function() {
			$(this).addClass('move_trip_err');
		});

		$.ajax({
			type: "POST",
		    async: "true",
		    url: '/admin/orders/move_trip_err_save/'+order_id+'/'+item,
		    data: {err_txt: log_error},
			dataType: 'json',
			success: function (data) {

			}
		});
	},

	closeAllPopups: () => {

		PNotify.removeAll();

		$('.btn-close-all-popups').hide().unbind();
	}
}

module.exports.closeAllPopups = closeAllPopups;
},{}],5:[function(require,module,exports){
const hasSupport = () => typeof(Storage) !== "undefined";

/**
 * Storage (Session and Local) module
 * */
function Storage (_s) {
	/**
	 * Set value to session storage
	 * @param {String} key
	 * @param {*} value
	 * */
	this.set = (key, value) => {
		if (key && hasSupport()) {
			if (value && Object.prototype.toString.call( value ) === "[object Object]") {
				_s.setItem(key, JSON.stringify(value));
			} else _s.setItem(key, value);
		}

	}
	/**
	 * Get value from session storage
	 * @param {String} key
	 * @return {Object|String} res
	 * */
	this.get = key => {
		if (key && hasSupport()) {
			const res = _s.getItem(key)
			try {
				return JSON.parse(res);
			} catch (e) {
				return res;
			}
		}
	}
	/**
	 * Remove value from session storage
	 * @param {String} key
	 * */
	this.delete = key => {
		if (key && hasSupport()) _s.removeItem(key);
	}
}

module.exports = {

	getLocalStorage: () => new Storage(localStorage),

	getSessionStorage: () => new Storage(sessionStorage),

	switchAccountHandler: () => {

		if (hasSupport()) {

			const localUnit = new Storage(localStorage);

			// intercept events
	        window.addEventListener("storage", e => {

	            if (e.key === 'switchAccount') { // switchAccount refresh tabs handle

	                localUnit.delete('switchAccount');

	                setTimeout( () => window.location.reload(), 7500);
	            }
	        });

	        // remove key after page loaded if duplicated tabs not found
	        window.addEventListener('pageshow', () => localUnit.delete('switchAccount'));
		}
	}
}
},{}],6:[function(require,module,exports){
const NotyficationModule = require('./notification.js');

const registeredRules = new Rules();

const isValidPrice = v => (v - 0) == v && (''+v).replace(/^\s+|\s+$/g, "").length > 0 && (Number(v) > 0 || Number(v) === 0) ? true : false;

function Rules() {

    this.isNotEmpty = v => typeof v === 'string' ? !!v.trim() : !!v;

    this.isPositiveNumber = v => v !== '' && (v - 0) == v && (''+v).replace(/^\s+|\s+$/g, "").length > 0 && Number(v) > 0 ? true : false;

    this.hasPositiveNumber = v => v === '' || (v - 0) == v && (''+v).replace(/^\s+|\s+$/g, "").length > 0 && Number(v) > 0 ? true : false;

    this.isInteger = v => /^-?[\d]+$/.test(v);

    this.integerOnly = v => v !== '' && this.isInteger((''+v).replace(/^\s+|\s+$/g, ""));

    this.isValidPrice = v => isValidPrice(v);

    this.isAlphaNumeric = v => /^[a-z0-9]+$/i.test(v);

    this.isNaturalNumber = v => v === '' || this.isInteger(v) && Number(v) >= 0;

    this.isValidPayment = v => !isNaN(v) && +v >= 0.01 ? true : false;
}

Rules.validate = function(rules,valuesToCheck) {

    const wrapper = this;
    const resp = {success: true, fields: []};

    for(field in valuesToCheck) {

        const _e = wrapper[0].querySelector(`[name="${field}"]`);

        if(_e != null && _e.disabled) continue; // do not check if field is disabled

        rules.forEach(rule => {

            if(resp.fields.includes(field)) return;

            if(registeredRules.hasOwnProperty(rule)) {

                if(!registeredRules[rule](valuesToCheck[field])) {

                    resp.success = false;
                    resp.fields.push(field);
                }

            } else if(!rule.bind(wrapper)(valuesToCheck[field])) {

                resp.success = false;
                resp.fields.push(field);
            }
            
        });
    }

    return resp;
}

const getValuesToCheck = (elements,i,field) => {
    
    const {name,keys,multi} = field;

    // compose simple key/value pairs from elements
    const values = elements.reduce((_set,_field) => {

        _set[_field.name] = _field.value;
        
        return _set;
    },{});

    if(keys.length && multi) {

        // find values to be ckecked on this step
        return keys.reduce((_set,key) => {

            const _name = `${name}[${i}][${key}]`;

            if (Object.keys(values).includes(_name)) _set[_name] = values[_name];

            return _set;
        },{});

    } 

    const _name = name + `${multi ? `[]` : ``}`;

    if(!(name instanceof RegExp) && !keys.length && !Object.keys(values).includes(_name)) values[_name] = '';

    return values;
}

const displayValidationErrors = function(fields,error, sA, cb) {

    const FormModule = require('./form.js');

    if(sA) {
        NotyficationModule.displayMessage({
            title: "Oops!",
            text: error,
            type: "notice",
        });
    }

    const names = fields.map(key => `[name="${key}"]`).join(', ');

    FormModule.showRawValidationError.call(this.find(names), error);

    // very custom callback for specific field. It should be defined at config level
    return cb ? cb.call(this) : false;
}

module.exports = {

	run: (config,data,wrapper,showPopUpAlert = true) => {

        return new Promise((resolve,reject) => {

            let result = true;

            config.map(field => {

                let elements;

                const {name,keys,rules,multi} = field;

                const error = (typeof field.error === 'function') ? field.error.call(wrapper) : field.error;
                const callback = (typeof field.callback === 'function') ? field.callback : false;

                // get specific form's data
                if(name instanceof RegExp) {

                    const reg = new RegExp( name.source );

                    elements = data.filter(f => reg.test(f.name));
                } else {

                    const reg = new RegExp( name + (multi ? '\\[\\d?\\]' : '') + (keys.length ? `\\[(${keys.join('|')})\\]` : '') );

                    elements = data.filter(f => ((multi || keys.length) ? reg.test(f.name) : f.name === field.name));
                }

                // "multi" fields have counter for each set: [0,1,2...]
                const steps = (multi && keys.length ? Object.keys(elements).length/keys.length : 1);

                for(let i=0; i < steps; i++) {

                    // we can check simple fields just by values while complex fields by their keys
                    const valuesToCheck = getValuesToCheck(elements, i, field);

                    // go through specific validation methods
                    const resp = Rules.validate.call(wrapper,rules,valuesToCheck);

                    // errors here
                    if(resp.success !== true) {

                        result = false;

                        displayValidationErrors.call(wrapper, resp.fields, error, showPopUpAlert, callback);
                    }
                }
            });

            if(!result) reject();

            resolve();
        });
    },

    isValidPrice
}
},{"./form.js":3,"./notification.js":4}]},{},[1]);
